import config from "./config.json";

export const b2cPolicies = {
	names: {
		signUpSignIn: config.msal.policies.signUpSignIn,
	},
	authorities: {
		signUpSignIn: {
			authority: `https://${config.msal.tenantName}.b2clogin.com/tfp/${config.msal.tenant}/${config.msal.policies.signUpSignIn}`
		},
	},
	authorityDomain: `${config.msal.tenantName}.b2clogin.com`,
};

export const msalConfig = {
	auth: {
		clientId: config.msal.clientId,
		authority: b2cPolicies.authorities.signUpSignIn.authority,
		knownAuthorities: [b2cPolicies.authorityDomain],
		redirectUri: config.msal.redirectUri,
		postLogoutRedirectUri: config.msal.postLogoutRedirectUri
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: false,
	},
};

export const loginRequest = { scopes: ["openid", "offline_access"] };

export const graphConfig = {
	graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
